import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public-user-accounts', {
        url: '/public-user-accounts',
        views: {
            '': 'userPublicUserAccounts',
            'header@user': 'userPublicUserAccountsHeader',
        },
        resolve: {authenticators,passwordManagers},
    })
}

/** @ngInject */
function authenticators($filter, Authenticator) {
    return Authenticator.query().$promise
        .then((items) => $filter('orderBy')(items, 'publicService.serviceName'));
}

/** @ngInject */
function passwordManagers($filter, PasswordManagers) {
    return PasswordManagers.list()
        .then((items) => $filter('orderBy')(items, 'publicService.serviceName'));
}


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/public-user-accounts.state.js